import React from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import { CommonBackContent } from '@/components/Layouts/CommonBackContent';

const AboutUsContent = () => {
  return (
    <CommonBackContent>
      <div className={classNames(styles.content, '')}>
        <h1>HairPaca Terms of Use</h1>
        <div className={styles.section}>
          <h2>Acceptance of Terms</h2>
          <p>
            Hairpaca.net provides you (the user) with online virtual hairstyle try-ons and related features, subject to
            your acceptance of all the terms, conditions, policies, and notices stated here.
          </p>
          <p>
            By visiting our site and using our services, you engage in our “Service” and agree to be bound by the
            following terms and conditions (“Terms of Service”, “Terms of Use”, “Terms”), including those additional
            terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service
            apply to all users of the site.
          </p>
          <p>
            This document is legally binding and governs your use of our Services. The Service includes the online
            virtual hairstyle try-ons, and any other services or features we may provide.
          </p>
          <p>
            This Agreement is entered into by Hairpaca and you, the entity or person agreeing to these terms
            (“Customer”), and governs the Customer’s access to and use of the Services.
          </p>
          <p>
            This Agreement becomes effective when the Customer acknowledges acceptance and proceeds to use the Services
            (the “Effective Date”).
          </p>
          <p>
            We reserve the right to update, change or replace any part of these Terms of Service by posting updates
            and/or changes to our website. It is your responsibility to check this page periodically for changes. Your
            continued use of or access to the website following the posting of any changes constitutes acceptance of
            those changes.
          </p>
        </div>
        <div className={styles.section}>
          <h2>Service Description and Use</h2>
          <p>
            Hairpaca.net offers a unique AI-powered service that provides online hairstyle try-ons based on
            user-submitted photos, along with hairstyle information services. This service is for entertainment purposes
            only and should not be used for any medical, legal, or scientific purposes.
          </p>
          <h3>Service Usage</h3>
          <p>
            To use our service, users must upload a clear, recent digital photo of themselves. Our AI algorithm will
            analyze these images to provide an online virtual hairstyle try-on experience. Users will receive images
            showing different hairstyles as part of the predictive output.
          </p>
          <h3>Nature of Predictions</h3>
          <p>{`The generated hairstyle photos are created by AI algorithms and are speculative. They are not intended to accurately represent the user's actual hairstyle appearance. Users should understand that this technology is based on current AI capabilities, has limitations, and may evolve over time.`}</p>
          <h3>Service Modifications and Availability</h3>
          <p>
            We continuously strive to improve our service and may modify algorithms, features, or the user interface at
            any time without notice. While we aim for continuous availability, the service may experience downtime and
            maintenance periods.
          </p>
          <h3>User Responsibility</h3>
          <p>
            Users are responsible for ensuring that the photos they provide comply with our photo submission guidelines
            and do not infringe on any third-party rights. Users must also ensure they have the necessary rights and
            permissions to use the images they upload.
          </p>
          <h3>Age Restriction</h3>
          <p>
            Users must be at least 18 years old to use our service. By using our service, you represent and warrant that
            you meet this age requirement.
          </p>
        </div>
        <div className={styles.section}>
          <h2>Intellectual Property Rights and User Content</h2>
          <h3>Intellectual Property of Hairpaca.net</h3>
          <p>
            The technology, software, algorithms, methodologies, designs, and all other intellectual property related to
            Hairpaca.net’s services, including all predictive images generated by our AI (collectively referred to as
            “Our IP”), are the exclusive property of Hairpaca or its licensors. Use of Our IP is strictly limited to the
            scope of the services provided and does not transfer any intellectual property rights to the user.
          </p>
          <h3>User Content</h3>
          <p>
            When you upload images or any other content (collectively, “User Content”) to our platform, you retain all
            rights to your User Content. However, by uploading User Content, you grant Hairpaca.net a non-exclusive,
            worldwide, royalty-free license to use, reproduce, modify, adapt, publish, and display the User Content
            solely for the purpose of providing and improving our services.
          </p>
          <h3>Responsibility for User Content</h3>
          <p>
            You affirm, represent, and warrant that you own or have the necessary licenses, rights, consents, and
            permissions to publish the User Content you submit. You agree to not upload any content that infringes upon
            any intellectual property or personal rights of others.
          </p>
          <h3>Prohibited Content</h3>
          <p>
            Users must not upload content that is unlawful, offensive, threatening, libelous, defamatory, pornographic,
            obscene, or otherwise objectionable or that violates any party’s intellectual property or these Terms of
            Service.
          </p>
          <h3>Content Removal and Account Termination</h3>
          <p>
            Hairpaca.net reserves the right, but is not obligated, to remove or refuse any content for any reason at our
            sole discretion. Repeated infringement of intellectual property rights, including the rights of Hairpaca.net
            or other users, may result in the termination of your account and access to our services.
          </p>
          <h3>Hairstyle Influencers and Photos</h3>
          <p>
            All hairstyle influencers and their hairstyle photos displayed on Hairpaca are copyrighted by their
            respective owners. For removal requests, please contact help.pumpsoul@gmail.com.
          </p>
        </div>
        <div className={styles.section}>
          <h2>Privacy and Data Protection</h2>
          <h3>Data Collection and Usage</h3>
          <p>
            In the course of providing our services, Hairpaca.net collects and processes personal data as outlined in
            our Privacy Policy. This includes, but is not limited to, photographs uploaded by the user, and email
            addresses for delivering our service outputs. We are committed to protecting the privacy and security of our
            users’ data.
          </p>
          <h3>Purpose of Data Processing</h3>
          <p>
            The data provided by users is used exclusively for the purpose of generating AI-based predictions and for
            communicating with the user regarding the service. We do not use this data for any unrelated marketing or
            commercial purposes without explicit consent from the user.
          </p>
          <h3>Data Storage and Security</h3>
          <p>
            We implement a variety of security measures to maintain the safety of your personal data. However, no method
            of transmission over the Internet or method of electronic storage is 100% secure. Therefore, while we strive
            to use commercially acceptable means to protect your personal data, we cannot guarantee its absolute
            security.
          </p>
          <h3>User Rights and Data Management</h3>
          <p>
            Users have the right to access, rectify, or erase their personal data held by Hairpaca.net. Requests for
            data access or deletion can be made through our designated channels as specified in our Privacy Policy.
          </p>
          <h3>Third-Party Disclosure</h3>
          <p>
            We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information
            unless we provide users with advance notice. This does not include website hosting partners and other
            parties who assist us in operating our website, conducting our business, or serving our users, so long as
            those parties agree to keep this information confidential.
          </p>
          <h3>Compliance with Laws</h3>
          <p>
            We will disclose user information where required by law or subpoena or if we reasonably believe that such
            action is necessary to comply with the law and the reasonable requests of law enforcement or to protect the
            security or integrity of our Service.
          </p>
        </div>
        <div className={styles.section}>
          <h2>Limitations of Liability and Disclaimer of Warranties</h2>
          <h3>Service “As Is”</h3>
          <p>
            The services provided by Hairpaca.net are offered on an “as is” and “as available” basis. While we strive to
            maintain high standards for our services, Hairpaca.net does not guarantee that the services will be
            uninterrupted, timely, secure, or error-free.
          </p>
          <h3>Accuracy of Predictions</h3>
          <p>
            The AI-generated predictions are for entertainment purposes only and should not be relied upon for accuracy.
          </p>
          <h3>No Warranties</h3>
          <p>
            Hairpaca.net expressly disclaims all warranties of any kind, whether express or implied, including, but not
            limited to, implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
          </p>
          <h3>Limitation of Liability</h3>
          <p>
            In no event shall Hairpaca.net, Hairpaca, its directors, employees, partners, agents, suppliers, or
            affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i)
            your access to or use of or inability to access or use the services; (ii) any conduct or content of any
            third party on the services; (iii) any content obtained from the services; and (iv) unauthorized access, use
            or alteration of your transmissions or content, whether based on warranty, contract, tort (including
            negligence) or any other legal theory, whether or not we have been informed of the possibility of such
            damage.
          </p>
          <h3>User Responsibility</h3>
          <p>
            You agree to defend, indemnify and hold harmless Hairpaca.net and its licensee and licensors, and their
            employees, contractors, agents, officers and directors, from and against any and all claims, damages,
            obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney’s
            fees), resulting from or arising out of a) your use and access of the Service, by you or any person using
            your account and password, or b) a breach of these Terms.
          </p>
        </div>
        <div className={styles.section}>
          <h2>Payment, Refunds, and Service Modification</h2>
          <h3>Payment Terms</h3>
          <p>
            Access to the Hairpaca.net services may require payment of fees, as detailed on the website or through the
            service process. Users agree to pay all fees in accordance with the pricing and payment terms presented at
            the time of purchase. Fees are subject to change at Hairpaca.net’s sole discretion.
          </p>
          <h3>Refund Policy</h3>
          <p>
            Given the digital nature of our services and the immediate delivery of personalized content, we generally do
            not offer refunds. However, if there are exceptional circumstances where the service did not meet the
            expectations set by our platform, users may contact us for potential refund considerations. All refund
            requests must be made within a specified period of 7 days from the service delivery date.
          </p>
          <h3>Service Modification</h3>
          <p>
            Hairpaca.net reserves the right to modify or discontinue, temporarily or permanently, the service (or any
            part thereof) with or without notice. We are not liable to you or any third party for any modification,
            price change, suspension, or discontinuance of the service.
          </p>
          <h3>Changes in Fees</h3>
          <p>
            We may change our fees and payment policies for the Services from time to time, including the addition of
            costs for additional services or features. Any changes to fees will be announced through our platform and
            will not apply retroactively.
          </p>
          <h3>Billing Information</h3>
          <p>
            It is the user’s responsibility to provide accurate and complete billing information. Users must promptly
            update all information to keep the billing account current, complete, and accurate (such as a change in
            billing address, credit card number, or credit card expiration date), and users must promptly notify
            Hairpaca.net if their payment method is canceled or if they become aware of a potential breach of security.
          </p>
        </div>
        <div className={styles.section}>
          <h2>Termination and Account Cancellation</h2>
          <h3>Right to Terminate</h3>
          <p>
            Hairpaca.net reserves the right to terminate or suspend your account and bar access to the service
            immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and
            without limitation, including but not limited to a breach of the Terms.
          </p>
          <h3>Effect of Termination</h3>
          <p>
            Upon termination, your right to use the service will cease immediately. If you wish to terminate your
            account, you may simply discontinue using the service.
          </p>
          <h3>Survival of Terms</h3>
          <p>
            All provisions of the Terms which by their nature should survive termination shall survive termination,
            including, without limitation, ownership provisions, warranty disclaimers, indemnity, and limitations of
            liability.
          </p>
          <h3>User’s Responsibility on Termination</h3>
          <p>
            It is your responsibility to secure any data or personal content uploaded to Hairpaca.net prior to
            termination. We are not responsible for providing access to such data or content following termination.
          </p>
          <h3>Account Cancellation</h3>
          <p>
            Users may cancel their account at any time through the website’s account management features or by
            contacting customer support. Upon cancellation, all rights granted to you under these terms will immediately
            cease.
          </p>
        </div>
        <div className={styles.section}>
          <h2>General Provisions</h2>
          <h3>Governing Law</h3>
          <p>
            These Terms shall be governed and construed in accordance with the laws of the United States, without regard
            to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be
            considered a waiver of those rights.
          </p>
          <h3>Severability</h3>
          <p>
            If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions
            of these Terms will remain in effect.
          </p>
          <h3>Entire Agreement</h3>
          <p>
            These Terms constitute the entire agreement between us regarding our service, and supersede and replace any
            prior agreements we might have had between us regarding the service.
          </p>
          <h3>Amendments to Terms</h3>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes
            a material change will be determined at our sole discretion. By continuing to access or use our service
            after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the
            new terms, you are no longer authorized to use the service.
          </p>
          <h3>Contact Information</h3>
          <p>
            For any questions about these Terms, please contact us through the contact information provided on the
            Hairpaca.net website.
          </p>
          <h3>Force Majeure</h3>
          <p>
            Neither party shall be liable for any failure to perform its obligations where such failure results from any
            cause beyond the party’s reasonable control, including, but not limited to, mechanical, electronic, or
            communications failure or degradation.
          </p>
          <h3>Assignment</h3>
          <p>
            These Terms, and any rights and licenses granted hereunder, may not be transferred or assigned by you, but
            may be assigned by Hairpaca.net without restriction.
          </p>
        </div>
      </div>
    </CommonBackContent>
  );
};

export default AboutUsContent;

// const dfData = {
//   title: `${AppSettings.name} Terms Of Us`,
//   date: 'Effective Date: December 7, 2023',
//   list: [
//     {
//       title: `Introduction`,
//       list: [
//         `
//         Welcome to drfans.com (the "Site"), one of the best dark romance sites on the web. Here, you can find a wealth of dark romance books, movies, and comics. You can also find related interesting products and GPTs. This document constitutes a legally-binding agreement ("Agreement") governing the terms of our service.
//         `,
//         `BY ACCESSING AND USING THE SITE, YOU AGREE THAT YOU HAVE READ AND UNDERSTOOD THIS AGREEMENT AND THAT YOU AGREE WITH THE TERMS, AS WELL AS OUR PRIVACY POLICY.`,
//       ],
//     },
//     {
//       title: `License to Access and Use`,
//       list: [
//         `You can access to our site for your personal usage. Any other access or use of the site or its content violates this agreement and may break applicable copyright, trademark, or other laws.`,
//         `You may not access, use, or copy any portion of the site or its content through the use of bots, spiders, scrapers, web crawlers, indexing agents, or other automated devices. In no event will you reproduce, redistribute, duplicate, copy, sell, resell, or exploit for any commercial purpose any portion of the Site or its Content or any access to or use of the site or its content.`,
//       ],
//     },
//     {
//       title: `Copyright`,
//       list: [
//         `We do own copyright to the arrangement of information on our website. You agree not to copy, distribute, display, disseminate, or otherwise reproduce any of the information on our site, or our site itself, without our prior written permission. This includes, but is not limited to, a prohibition on aggregating information on our site that is in the public domain and publishing it elsewhere.`,
//         `That means you can share contents to your facebook profile, your twitter or you website with a link to ${AppSettings.name} (and we, of course, welcome it), but you cannot use a group or a list of our quotes on your website.`,
//         `All images published on ${AppSettings.name} are protected by copyright. But you can share our images under the condition that they link back to ${AppSettings.name}.`,
//       ],
//     },
//     {
//       title: `Design Copyright`,
//       list: [
//         `You agree not to copy the look and feel of our site or its design, or part of its design, without our prior written consent. `,
//       ],
//     },
//     {
//       title: `Information supplied`,
//       list: [
//         `By disclosing or offering any information to us, including ideas, suggestions or other information (each, a "Submission"), either through your use of the site or otherwise, you authorize ${AppSettings.name} to make such copies thereof as we deem necessary, including to facilitate the posting and storage of the submission on the site. By making a submission, you automatically grant to ${AppSettings.name} an irrevocable, perpetual, non-exclusive, transferable, royalty-free, worldwide license (with the right to sublicense) to use, copy, adapt, publish, publicly perform, publicly display, reformat, translate, excerpt (in whole or in part) and distribute such submission for any purpose, commercial, advertising, or otherwise, on or in connection with the site or the promotion thereof, to prepare derivative works or incorporate into other works. By submitting content to our site, you grant and authorize sublicenses of the foregoing. We'd also point out that we don't pay for anything you submit to us via our submission form or suggestion email inbox simply because you provide it of your own volition. By submitting material to us, you acknowledge that you have the right to do so, and that you completely transfer rights of the content to us. `,
//       ],
//     },
//     {
//       title: `Termination of user's access`,
//       list: [
//         `${AppSettings.name} reserves the right in its sole discretion to terminate your access to all or part of the site without notice or liability. We can do this for any reason including but not limited to, the breach of any agreement between you and ${AppSettings.name}, including without limitation, this Agreement. `,
//       ],
//     },
//     {
//       title: `Children protection`,
//       list: [
//         `According to the Children's Online Privacy Protection Act (COPPA), ${AppSettings.name} does not knowingly collect or ask for personal information from anyone under the age of 13 or knowingly allow such persons to register. If you are under 13, please do not send any information about yourself to us, including your photos, videos, name, address, telephone number, or email address, by using our contact form or by creating an account on ${AppSettings.name}. No one under age 13 is allowed to provide any personal information to or on ${AppSettings.name}. In the event that we learn that we have collected personal information from a child under age 13 without verification of parental consent, we will delete that information as quickly as possible. If you believe that we might have any information from or about a child under 13, please contact us. `,
//       ],
//     },
//     {
//       title: `Hyperlinks`,
//       list: [
//         `${AppSettings.name} may include hyperlinks that are not maintained by ${AppSettings.name}. We do not own any responsibility for the content of this links or opinions expressed in it, or other links provided by such websites. The terms of service and privacy policies applicable to external websites may be different from those applicable to our Site. If you decide to access any external website through a link within our Site, you do so entirely at your own risk, and ${AppSettings.name} will have no liability for any loss or damage arising from your access or use of any external website. `,
//         `You agree that you will bring no suit or claim against us arising from or based upon any such use of external websites.`,
//       ],
//     },
//     {
//       title: `Disclaimer`,
//       list: [
//         `YOU USE THIS SITE AT YOUR OWN RISK. THE SITE AND ITS CONTENT ARE OFFERED WITHOUT WARRANTY OF ANY KIND. IT INCLUDES: (1) THE MERCHANTABILITY OF OUR SERVICE OR FITNESS FOR ANY PARTICULAR PURPOSE (2) THAT THE USE OF THIS SITE OR ANY THIRD PARTY WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE (3) THAT THE USE OF THIS SITE OR ANY SUCH THIRD PARTY WEBSITE WILL ALLOW YOU TO OBTAIN ANY PARTICULAR RESULTS WHATSOEVER (4) ANY OTHER INFORMATION PROVIDED THROUGH THIS SITE OR ANY THIRD PARTY WEBSITE ARE OR WILL BE ACCURATE, CURRENT, COMPLETE, RELIABLE, OR OF ANY PARTICULAR VALUE OR QUALITY (5) THAT ANY DEFECTS IN THE SITE OR ITS CONTENT WILL BE CORRECTED (6) THAT THE SITE AND ITS CONTENTS ARE FREE OF VIRUSES OR OTHER DISABLING DEVICES OR HARMFUL COMPONENTS.`,
//         `Though we try to do our best, we can't guarantee the authorship of quotation for 100% percents. We do not carry responsibility for the usage of quotations with an incorrect author or content.`,
//         `${AppSettings.name} may not share the opinion of our authors, as well as we do not carry any responsibility for the opinions.`,
//       ],
//     },
//     {
//       title: `Limitation of Liability`,
//       list: [
//         `IN NO EVENT WILL ${AppSettings.name}, ITS CONTRACTORS, SUPPLIERS, CONTENT-PROVIDERS, AND OTHER SIMILAR ENTITIES, AND THE OFFICERS, DIRECTORS, EMPLOYEES, REPRESENTATIVES, AND AGENTS OF EACH OF THE FOREGOING (COLLECTIVELY, OUR "REPRESENTATIVES"), BE LIABLE TO YOU, OR ANY THIRD PARTY FOR ANY LOSSES OR DAMAGES, INCLUDING ANY INDIRECT, CONSEQUENTIAL, INCIDENTAL, PUNITIVE, SPECIAL OR SIMILAR DAMAGES, ALLEGED UNDER ANY LEGAL THEORY IN RELATION TO OR ARISING FROM THIS AGREEMENT OR OUR SERVICE, FOR REASONS INCLUDING, BUT NOT LIMITED TO, FAILURE OF OUR SERVICE, NEGLIGENCE,  OR ANY OTHER TORT. TO THE EXTENT THAT APPLICABLE LAW RESTRICTS THE EXCLUSION OR LIMITATION OF LIABILITY FOR CERTAIN DAMAGES, YOU AGREE THAT WE ARE ONLY LIABLE TO YOU FOR THE MINIMUM AMOUNT OF DAMAGES THAT THE LAW RESTRICTS OUR LIABILITY TO, IF SUCH A MINIMUM EXISTS. WITHOUT LIMITING ANY OF THE FOREGOING, IF ${AppSettings.name} OR ANY OF ITS REPRESENTATIVES IS FOUND LIABLE TO YOU OR TO ANY THIRD PARTY AS A RESULT OF ANY CLAIMS OR OTHER MATTERS ARISING UNDER OR IN CONNECTION WITH THIS AGREEMENT, THE SITE, OR YOUR USE OF THE SITE OR ITS CONTENTS, THE MAXIMUM LIABILITY FOR ALL SUCH CLAIMS AND OTHER MATTERS WILL NOT EXCEED $100 IN ANY CALENDAR YEAR. `,
//       ],
//     },
//     {
//       title: `Amendments`,
//       list: [
//         `We may amend this agreement from time to time. When we amend this agreement, we will update this page and indicate the date that it was last modified. You may refuse to agree to the amendments, but if you do, you must immediately cease using our website and our service. You must visit this page each time you come to our website and read and agree to it if the date it was last modified is more recent than the last time you agreed to the agreement. `,
//       ],
//     },
//     {
//       title: `Contact Us`,
//       list: [
//         `All feedback, questions, and comments  in connection with our terms should be directed to: <a href='mailto:help.pumpsoul@gmail.com'>help.pumpsoul@gmail.com</a>.`,
//       ],
//     },
//   ],
// };

// const qtData = {
//   title: `${AppSettings.name} Terms Of Us`,
//   date: 'Effective Date: December 7, 2023',
//   list: [
//     {
//       title: `Introduction`,
//       list: [
//         `
//         Welcome to Quotesecho.com (the "Site"), one of the best quotation sites on the web. Here, you can find various quotes information, as well as related products and interesting applications. This document constitutes a legally-binding agreement ("Agreement") governing the terms of our service.
//         `,
//         `BY ACCESSING AND USING THE SITE, YOU AGREE THAT YOU HAVE READ AND UNDERSTOOD THIS AGREEMENT AND THAT YOU AGREE WITH THE TERMS, AS WELL AS OUR PRIVACY POLICY.`,
//       ],
//     },
//     {
//       title: `License to Access and Use`,
//       list: [
//         `You can access to our site for your personal usage. Any other access or use of the site or its content violates this agreement and may break applicable copyright, trademark, or other laws.`,
//         `You may not access, use, or copy any portion of the site or its content through the use of bots, spiders, scrapers, web crawlers, indexing agents, or other automated devices. In no event will you reproduce, redistribute, duplicate, copy, sell, resell, or exploit for any commercial purpose any portion of the Site or its Content or any access to or use of the site or its content.`,
//       ],
//     },
//     {
//       title: `Copyright`,
//       list: [
//         `We do not own the exclusive rights to quotes that other people have said. But we do own copyright to the arrangement of information on our website. You agree not to copy, distribute, display, disseminate, or otherwise reproduce any of the information on our site, or our site itself, without our prior written permission. This includes, but is not limited to, a prohibition on aggregating information on our site that is in the public domain and publishing it elsewhere.`,
//         `That means you can share a quote to your facebook profile, your twitter or you website with a link to ${AppSettings.name} (and we, of course, welcome it), but you cannot use a group or a list of our quotes on your website.`,
//         `All images published on ${AppSettings.name} are protected by copyright. But you can share our images under the condition that they link back to ${AppSettings.name}.`,
//       ],
//     },
//     {
//       title: `Design Copyright`,
//       list: [
//         `You agree not to copy the look and feel of our site or its design, or part of its design, without our prior written consent. `,
//       ],
//     },
//     {
//       title: `Information supplied`,
//       list: [
//         `By disclosing or offering any information to us, including quotes, ideas, suggestions or other information (each, a "Submission"), either through your use of the site or otherwise, you authorize ${AppSettings.name} to make such copies thereof as we deem necessary, including to facilitate the posting and storage of the submission on the site. By making a submission, you automatically grant to ${AppSettings.name} an irrevocable, perpetual, non-exclusive, transferable, royalty-free, worldwide license (with the right to sublicense) to use, copy, adapt, publish, publicly perform, publicly display, reformat, translate, excerpt (in whole or in part) and distribute such submission for any purpose, commercial, advertising, or otherwise, on or in connection with the site or the promotion thereof, to prepare derivative works or incorporate into other works. By submitting content to our site, you grant and authorize sublicenses of the foregoing. We'd also point out that we don't pay for anything you submit to us via our submission form or suggestion email inbox simply because you provide it of your own volition. By submitting material to us, you acknowledge that you have the right to do so, and that you completely transfer rights of the content to us. `,
//       ],
//     },
//     {
//       title: `Termination of user's access`,
//       list: [
//         `${AppSettings.name} reserves the right in its sole discretion to terminate your access to all or part of the site without notice or liability. We can do this for any reason including but not limited to, the breach of any agreement between you and ${AppSettings.name}, including without limitation, this Agreement. `,
//       ],
//     },
//     {
//       title: `Children protection`,
//       list: [
//         `According to the Children's Online Privacy Protection Act (COPPA), ${AppSettings.name} does not knowingly collect or ask for personal information from anyone under the age of 13 or knowingly allow such persons to register. If you are under 13, please do not send any information about yourself to us, including your photos, videos, name, address, telephone number, or email address, by using our contact form or by creating an account on ${AppSettings.name}. No one under age 13 is allowed to provide any personal information to or on ${AppSettings.name}. In the event that we learn that we have collected personal information from a child under age 13 without verification of parental consent, we will delete that information as quickly as possible. If you believe that we might have any information from or about a child under 13, please contact us. `,
//       ],
//     },
//     {
//       title: `Hyperlinks`,
//       list: [
//         `${AppSettings.name} may include hyperlinks that are not maintained by ${AppSettings.name}. We do not own any responsibility for the content of this links or opinions expressed in it, or other links provided by such websites. The terms of service and privacy policies applicable to external websites may be different from those applicable to our Site. If you decide to access any external website through a link within our Site, you do so entirely at your own risk, and ${AppSettings.name} will have no liability for any loss or damage arising from your access or use of any external website. `,
//         `You agree that you will bring no suit or claim against us arising from or based upon any such use of external websites.`,
//       ],
//     },
//     {
//       title: `Disclaimer`,
//       list: [
//         `YOU USE THIS SITE AT YOUR OWN RISK. THE SITE AND ITS CONTENT ARE OFFERED WITHOUT WARRANTY OF ANY KIND. IT INCLUDES: (1) THE MERCHANTABILITY OF OUR SERVICE OR FITNESS FOR ANY PARTICULAR PURPOSE (2) THAT THE USE OF THIS SITE OR ANY THIRD PARTY WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE (3) THAT THE USE OF THIS SITE OR ANY SUCH THIRD PARTY WEBSITE WILL ALLOW YOU TO OBTAIN ANY PARTICULAR RESULTS WHATSOEVER (4) THAT THE QUOTES OR ANY OTHER INFORMATION PROVIDED THROUGH THIS SITE OR ANY THIRD PARTY WEBSITE ARE OR WILL BE ACCURATE, CURRENT, COMPLETE, RELIABLE, OR OF ANY PARTICULAR VALUE OR QUALITY (5) THAT ANY DEFECTS IN THE SITE OR ITS CONTENT WILL BE CORRECTED (6) THAT THE SITE AND ITS CONTENTS ARE FREE OF VIRUSES OR OTHER DISABLING DEVICES OR HARMFUL COMPONENTS.`,
//         `Though we try to do our best, we can't guarantee the authorship of quotation for 100% percents. We do not carry responsibility for the usage of quotations with an incorrect author or content.`,
//         `${AppSettings.name} may not share the opinion of our authors, as well as we do not carry any responsibility for the opinions, that are expressed in quotes on our website.`,
//       ],
//     },
//     {
//       title: `Limitation of Liability`,
//       list: [
//         `IN NO EVENT WILL ${AppSettings.name}, ITS CONTRACTORS, SUPPLIERS, CONTENT-PROVIDERS, AND OTHER SIMILAR ENTITIES, AND THE OFFICERS, DIRECTORS, EMPLOYEES, REPRESENTATIVES, AND AGENTS OF EACH OF THE FOREGOING (COLLECTIVELY, OUR "REPRESENTATIVES"), BE LIABLE TO YOU, OR ANY THIRD PARTY FOR ANY LOSSES OR DAMAGES, INCLUDING ANY INDIRECT, CONSEQUENTIAL, INCIDENTAL, PUNITIVE, SPECIAL OR SIMILAR DAMAGES, ALLEGED UNDER ANY LEGAL THEORY IN RELATION TO OR ARISING FROM THIS AGREEMENT OR OUR SERVICE, FOR REASONS INCLUDING, BUT NOT LIMITED TO, FAILURE OF OUR SERVICE, NEGLIGENCE, TOTALLY INACCURATE QUOTES THAT WERE EITHER NEVER SAID BY ANYBODY NOTABLE OR JUST ATTRIBUTED TO THE WRONG PERSON (WE DON'T KNOW HOW THAT'S WORTHY OF A LAWSUIT, BUT WHATEVER), OR ANY OTHER TORT. TO THE EXTENT THAT APPLICABLE LAW RESTRICTS THE EXCLUSION OR LIMITATION OF LIABILITY FOR CERTAIN DAMAGES, YOU AGREE THAT WE ARE ONLY LIABLE TO YOU FOR THE MINIMUM AMOUNT OF DAMAGES THAT THE LAW RESTRICTS OUR LIABILITY TO, IF SUCH A MINIMUM EXISTS. WITHOUT LIMITING ANY OF THE FOREGOING, IF ${AppSettings.name} OR ANY OF ITS REPRESENTATIVES IS FOUND LIABLE TO YOU OR TO ANY THIRD PARTY AS A RESULT OF ANY CLAIMS OR OTHER MATTERS ARISING UNDER OR IN CONNECTION WITH THIS AGREEMENT, THE SITE, OR YOUR USE OF THE SITE OR ITS CONTENTS, THE MAXIMUM LIABILITY FOR ALL SUCH CLAIMS AND OTHER MATTERS WILL NOT EXCEED $100 IN ANY CALENDAR YEAR. `,
//       ],
//     },
//     {
//       title: `Amendments`,
//       list: [
//         `We may amend this agreement from time to time. When we amend this agreement, we will update this page and indicate the date that it was last modified. You may refuse to agree to the amendments, but if you do, you must immediately cease using our website and our service. You must visit this page each time you come to our website and read and agree to it if the date it was last modified is more recent than the last time you agreed to the agreement. `,
//       ],
//     },
//     {
//       title: `Contact Us`,
//       list: [
//         `All feedback, questions, and comments  in connection with our terms should be directed to: <a href='mailto:help.pumpsoul@gmail.com'>help.pumpsoul@gmail.com</a>.`,
//       ],
//     },
//   ],
// };

// const otherData = {
//   title: `${AppSettings.name} Terms Of Us`,
//   date: 'Effective Date: December 7, 2023',
//   list: [
//     {
//       title: `Introduction`,
//       list: [
//         '3' == AppSettings.type
//           ? `
//         Welcome to Momsgpts.com (the "Site"). Our mission is to empower and support mothers by offering expert advice, articles, and resources on topics such as prenatal care, breastfeeding, childcare tips, and self-care for moms. This document constitutes a legally-binding agreement ("Agreement") governing the terms of our service.
//         `
//           : `
//         Welcome to huntpink.com (the "Site"), This site is your destination for all things pink! We are your one-stop source for the latest trends, products, and news related to the color pink. This document constitutes a legally-binding agreement ("Agreement") governing the terms of our service.
//         `,
//         `
//         BY ACCESSING AND USING THE SITE, YOU AGREE THAT YOU HAVE READ AND UNDERSTOOD THIS AGREEMENT AND THAT YOU AGREE WITH THE TERMS, AS WELL AS OUR PRIVACY POLICY.
//         `,
//       ],
//     },
//     {
//       title: `License to Access and Use`,
//       list: [
//         `You can access to our site for your personal usage. Any other access or use of the site or its content violates this agreement and may break applicable copyright, trademark, or other laws.`,
//         `You may not access, use, or copy any portion of the site or its content through the use of bots, spiders, scrapers, web crawlers, indexing agents, or other automated devices. In no event will you reproduce, redistribute, duplicate, copy, sell, resell, or exploit for any commercial purpose any portion of the Site or its Content or any access to or use of the site or its content.`,
//       ],
//     },
//     {
//       title: `Copyright`,
//       list: [
//         `We do own copyright to the arrangement of information on our website. You agree not to copy, distribute, display, disseminate, or otherwise reproduce any of the information on our site, or our site itself, without our prior written permission. This includes, but is not limited to, a prohibition on aggregating information on our site that is in the public domain and publishing it elsewhere.`,
//         `That means you can share a quote to your facebook profile, your twitter or you website with a link to ${AppSettings.name} (and we, of course, welcome it), but you cannot use a group or a list of our quotes on your website.`,
//         `All images published on ${AppSettings.name} are protected by copyright. But you can share our images under the condition that they link back to ${AppSettings.name}.`,
//       ],
//     },
//     {
//       title: `Design Copyright`,
//       list: [
//         `You agree not to copy the look and feel of our site or its design, or part of its design, without our prior written consent. `,
//       ],
//     },
//     {
//       title: `Information supplied`,
//       list: [
//         `By disclosing or offering any information to us, including quotes, ideas, suggestions or other information (each, a "Submission"), either through your use of the site or otherwise, you authorize ${AppSettings.name} to make such copies thereof as we deem necessary, including to facilitate the posting and storage of the submission on the site. By making a submission, you automatically grant to ${AppSettings.name} an irrevocable, perpetual, non-exclusive, transferable, royalty-free, worldwide license (with the right to sublicense) to use, copy, adapt, publish, publicly perform, publicly display, reformat, translate, excerpt (in whole or in part) and distribute such submission for any purpose, commercial, advertising, or otherwise, on or in connection with the site or the promotion thereof, to prepare derivative works or incorporate into other works. By submitting content to our site, you grant and authorize sublicenses of the foregoing. We'd also point out that we don't pay for anything you submit to us via our submission form or suggestion email inbox simply because you provide it of your own volition. By submitting material to us, you acknowledge that you have the right to do so, and that you completely transfer rights of the content to us. `,
//       ],
//     },
//     {
//       title: `Termination of user's access`,
//       list: [
//         `${AppSettings.name} reserves the right in its sole discretion to terminate your access to all or part of the site without notice or liability. We can do this for any reason including but not limited to, the breach of any agreement between you and ${AppSettings.name}, including without limitation, this Agreement. `,
//       ],
//     },
//     {
//       title: `Children protection`,
//       list: [
//         `According to the Children's Online Privacy Protection Act (COPPA), ${AppSettings.name} does not knowingly collect or ask for personal information from anyone under the age of 13 or knowingly allow such persons to register. If you are under 13, please do not send any information about yourself to us, including your photos, videos, name, address, telephone number, or email address, by using our contact form or by creating an account on ${AppSettings.name}. No one under age 13 is allowed to provide any personal information to or on ${AppSettings.name}. In the event that we learn that we have collected personal information from a child under age 13 without verification of parental consent, we will delete that information as quickly as possible. If you believe that we might have any information from or about a child under 13, please contact us. `,
//       ],
//     },
//     {
//       title: `Hyperlinks`,
//       list: [
//         `${AppSettings.name} may include hyperlinks that are not maintained by ${AppSettings.name}. We do not own any responsibility for the content of this links or opinions expressed in it, or other links provided by such websites. The terms of service and privacy policies applicable to external websites may be different from those applicable to our Site. If you decide to access any external website through a link within our Site, you do so entirely at your own risk, and ${AppSettings.name} will have no liability for any loss or damage arising from your access or use of any external website. `,
//         `You agree that you will bring no suit or claim against us arising from or based upon any such use of external websites.`,
//       ],
//     },
//     {
//       title: `Disclaimer`,
//       list: [
//         `YOU USE THIS SITE AT YOUR OWN RISK. THE SITE AND ITS CONTENT ARE OFFERED WITHOUT WARRANTY OF ANY KIND. IT INCLUDES: (1) THE MERCHANTABILITY OF OUR SERVICE OR FITNESS FOR ANY PARTICULAR PURPOSE (2) THAT THE USE OF THIS SITE OR ANY THIRD PARTY WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE (3) THAT THE USE OF THIS SITE OR ANY SUCH THIRD PARTY WEBSITE WILL ALLOW YOU TO OBTAIN ANY PARTICULAR RESULTS WHATSOEVER (4) THAT THE QUOTES OR ANY OTHER INFORMATION PROVIDED THROUGH THIS SITE OR ANY THIRD PARTY WEBSITE ARE OR WILL BE ACCURATE, CURRENT, COMPLETE, RELIABLE, OR OF ANY PARTICULAR VALUE OR QUALITY (5) THAT ANY DEFECTS IN THE SITE OR ITS CONTENT WILL BE CORRECTED (6) THAT THE SITE AND ITS CONTENTS ARE FREE OF VIRUSES OR OTHER DISABLING DEVICES OR HARMFUL COMPONENTS.`,
//         `Though we try to do our best, we can't guarantee the authorship of quotation for 100% percents. We do not carry responsibility for the usage of quotations with an incorrect author or content.`,
//         `${AppSettings.name} may not share the opinion of our authors, as well as we do not carry any responsibility for the opinions, that are expressed in quotes on our website.`,
//       ],
//     },
//     {
//       title: `Limitation of Liability`,
//       list: [
//         `IN NO EVENT WILL ${AppSettings.name}, ITS CONTRACTORS, SUPPLIERS, CONTENT-PROVIDERS, AND OTHER SIMILAR ENTITIES, AND THE OFFICERS, DIRECTORS, EMPLOYEES, REPRESENTATIVES, AND AGENTS OF EACH OF THE FOREGOING (COLLECTIVELY, OUR "REPRESENTATIVES"), BE LIABLE TO YOU, OR ANY THIRD PARTY FOR ANY LOSSES OR DAMAGES, INCLUDING ANY INDIRECT, CONSEQUENTIAL, INCIDENTAL, PUNITIVE, SPECIAL OR SIMILAR DAMAGES, ALLEGED UNDER ANY LEGAL THEORY IN RELATION TO OR ARISING FROM THIS AGREEMENT OR OUR SERVICE, FOR REASONS INCLUDING, BUT NOT LIMITED TO, FAILURE OF OUR SERVICE, NEGLIGENCE, OR ANY OTHER TORT. TO THE EXTENT THAT APPLICABLE LAW RESTRICTS THE EXCLUSION OR LIMITATION OF LIABILITY FOR CERTAIN DAMAGES, YOU AGREE THAT WE ARE ONLY LIABLE TO YOU FOR THE MINIMUM AMOUNT OF DAMAGES THAT THE LAW RESTRICTS OUR LIABILITY TO, IF SUCH A MINIMUM EXISTS. WITHOUT LIMITING ANY OF THE FOREGOING, IF ${AppSettings.name} OR ANY OF ITS REPRESENTATIVES IS FOUND LIABLE TO YOU OR TO ANY THIRD PARTY AS A RESULT OF ANY CLAIMS OR OTHER MATTERS ARISING UNDER OR IN CONNECTION WITH THIS AGREEMENT, THE SITE, OR YOUR USE OF THE SITE OR ITS CONTENTS, THE MAXIMUM LIABILITY FOR ALL SUCH CLAIMS AND OTHER MATTERS WILL NOT EXCEED $100 IN ANY CALENDAR YEAR. `,
//       ],
//     },
//     {
//       title: `Amendments`,
//       list: [
//         `We may amend this agreement from time to time. When we amend this agreement, we will update this page and indicate the date that it was last modified. You may refuse to agree to the amendments, but if you do, you must immediately cease using our website and our service. You must visit this page each time you come to our website and read and agree to it if the date it was last modified is more recent than the last time you agreed to the agreement. `,
//       ],
//     },
//     {
//       title: `Contact Us`,
//       list: [
//         `All feedback, questions, and comments  in connection with our terms should be directed to: <a href='mailto:help.pumpsoul@gmail.com'>help.pumpsoul@gmail.com</a>.`,
//       ],
//     },
//   ],
// };

// const AboutUsContent = () => {
//   const data = () => {
//     switch (AppSettings.type) {
//       case '1':
//         return dfData;
//       case '2':
//         return qtData;
//       default:
//         return otherData;
//     }
//   };

//   return (
//     <div className={classNames(styles.popularProductsContainer, '')}>
//       <div className={styles.homeContent}>
//         <h1>{data().title}</h1>
//         <span>{data().date}</span>
//         {data().list.map((item, index) => {
//           return (
//             <div key={index + item.title}>
//               <h2>{item.title}</h2>
//               {item.list && (
//                 <>
//                   {item.list.map((subItem, subIndex) => {
//                     return <p key={subIndex} dangerouslySetInnerHTML={{ __html: subItem }} />;
//                   })}
//                 </>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default AboutUsContent;
